import type { ModelDefinition } from "@/models.js";

export const mistralModels = [
	{
		id: "mistral-large-latest",
		name: "Mistral Large Latest",
		description: "Mistral's flagship large model for complex reasoning tasks.",
		family: "mistral",
		releasedAt: new Date("2025-12-02"),
		providers: [
			{
				providerId: "mistral",
				externalId: "mistral-large-latest",
				inputPrice: "0.000004",
				outputPrice: "0.000012",
				requestPrice: "0",
				contextSize: 128000,
				maxOutput: undefined,
				streaming: true,
				vision: false,
				tools: false,
				jsonOutput: false,
			},
		],
	},
	{
		id: "pixtral-large-latest",
		name: "Pixtral Large Latest",
		description: "Mistral's multimodal model with vision capabilities.",
		family: "mistral",
		releasedAt: new Date("2024-11-18"),
		providers: [
			{
				providerId: "mistral",
				externalId: "pixtral-large-latest",
				inputPrice: "0.000004",
				outputPrice: "0.000012",
				requestPrice: "0",
				contextSize: 128000,
				maxOutput: undefined,
				streaming: true,
				vision: true,
				tools: false,
				jsonOutput: false,
				deactivatedAt: new Date("2026-07-13"),
			},
		],
	},
	{
		id: "mistral-large-2512",
		name: "Mistral Large 3",
		description:
			"Mistral's latest flagship model with 675B parameters and MoE architecture.",
		family: "mistral",
		releasedAt: new Date("2025-12-02"),
		providers: [
			{
				providerId: "mistral",
				externalId: "mistral-large-2512",
				inputPrice: "0.5e-6",
				outputPrice: "1.5e-6",
				requestPrice: "0",
				contextSize: 262144,
				maxOutput: undefined,
				streaming: true,
				vision: true,
				tools: false,
				jsonOutput: true,
			},
			{
				providerId: "aws-bedrock",
				externalId: "mistral.mistral-large-3-v1:0",
				inputPrice: "0.5e-6",
				outputPrice: "1.5e-6",
				requestPrice: "0",
				contextSize: 256000,
				maxOutput: undefined,
				streaming: true,
				vision: true,
				tools: true,
				jsonOutput: true,
				regions: [{ id: "us" }],
			},
		],
	},
	{
		id: "mistral-small-2506",
		name: "Mistral Small 3.2",
		description: "Lightweight 24B model for fast, efficient tasks.",
		family: "mistral",
		releasedAt: new Date("2025-06-20"),
		providers: [
			{
				providerId: "mistral",
				externalId: "mistral-small-2506",
				inputPrice: "0.1e-6",
				outputPrice: "0.3e-6",
				requestPrice: "0",
				contextSize: 128000,
				maxOutput: undefined,
				streaming: true,
				vision: true,
				tools: false,
				jsonOutput: true,
			},
		],
	},
	{
		id: "ministral-14b-2512",
		name: "Ministral 14B",
		description:
			"Largest Ministral model optimized for edge and local deployment.",
		family: "mistral",
		releasedAt: new Date("2025-12-02"),
		providers: [
			{
				providerId: "mistral",
				externalId: "ministral-14b-2512",
				inputPrice: "0.2e-6",
				outputPrice: "0.2e-6",
				requestPrice: "0",
				contextSize: 262144,
				maxOutput: undefined,
				streaming: true,
				vision: true,
				tools: false,
				jsonOutput: true,
			},
		],
	},
	{
		id: "ministral-8b-2512",
		name: "Ministral 8B",
		description: "Mid-size Ministral model for edge and local deployment.",
		family: "mistral",
		releasedAt: new Date("2025-12-02"),
		providers: [
			{
				providerId: "mistral",
				externalId: "ministral-8b-2512",
				inputPrice: "0.15e-6",
				outputPrice: "0.15e-6",
				requestPrice: "0",
				contextSize: 262144,
				maxOutput: undefined,
				streaming: true,
				vision: true,
				tools: false,
				jsonOutput: true,
			},
		],
	},
	{
		id: "ministral-3b-2512",
		name: "Ministral 3B",
		description: "Smallest Ministral model for efficient edge deployment.",
		family: "mistral",
		releasedAt: new Date("2025-12-02"),
		providers: [
			{
				providerId: "mistral",
				externalId: "ministral-3b-2512",
				inputPrice: "0.1e-6",
				outputPrice: "0.1e-6",
				requestPrice: "0",
				contextSize: 131072,
				maxOutput: undefined,
				streaming: true,
				vision: true,
				tools: false,
				jsonOutput: true,
			},
		],
	},
	{
		id: "codestral-2508",
		name: "Codestral",
		description:
			"Code specialist model for low-latency code generation and FIM.",
		family: "mistral",
		releasedAt: new Date("2025-07-30"),
		providers: [
			{
				providerId: "mistral",
				externalId: "codestral-2508",
				inputPrice: "0.3e-6",
				outputPrice: "0.9e-6",
				requestPrice: "0",
				contextSize: 256000,
				maxOutput: undefined,
				streaming: true,
				vision: false,
				tools: false,
				jsonOutput: true,
			},
		],
	},
	{
		id: "devstral-2512",
		name: "Devstral 2",
		description: "Frontier code agents model for software engineering tasks.",
		family: "mistral",
		releasedAt: new Date("2025-12-09"),
		providers: [
			{
				providerId: "mistral",
				externalId: "devstral-2512",
				inputPrice: "0.4e-6",
				outputPrice: "2e-6",
				requestPrice: "0",
				contextSize: 262144,
				maxOutput: undefined,
				streaming: true,
				vision: false,
				tools: false,
				jsonOutput: true,
			},
		],
	},
	{
		id: "devstral-small-2507",
		name: "Devstral Small 1.1",
		description:
			"Compact code model for codebase exploration and multi-file editing.",
		family: "mistral",
		releasedAt: new Date("2025-07-21"),
		providers: [
			{
				providerId: "mistral",
				externalId: "devstral-small-2507",
				inputPrice: "0.1e-6",
				outputPrice: "0.3e-6",
				requestPrice: "0",
				contextSize: 131072,
				maxOutput: undefined,
				streaming: true,
				vision: false,
				tools: false,
				jsonOutput: true,
				deactivatedAt: new Date("2026-07-13"),
			},
		],
	},
	{
		id: "mistral-ocr-latest",
		name: "Mistral OCR",
		description:
			"Mistral's OCR model that extracts text, tables, and structure from documents and images as markdown via the /v1/ocr endpoint.",
		family: "mistral",
		releasedAt: new Date("2025-03-06"),
		output: ["ocr"],
		providers: [
			{
				// OCR is billed per page and the Mistral key needs a separate OCR
				// entitlement, so a key without it makes the suite fail with a 401
				// that looks like a gateway bug. Opt in with
				// TEST_MODELS="mistral/mistral-ocr-latest".
				test: "skip",
				providerId: "mistral",
				externalId: "mistral-ocr-latest",
				inputPrice: "0",
				outputPrice: "0",
				requestPrice: "0",
				ocrPagePrice: "0.004",
				contextSize: 0,
				maxOutput: undefined,
				streaming: false,
				vision: true,
				tools: false,
				jsonOutput: false,
				ocr: true,
			},
		],
	},
] as const satisfies ModelDefinition[];
